<div class="calculator-container" (click)="$event.stopPropagation()">
  @if (formItems) {
    <form [formGroup]="form" class="transparent" appFormErrorScroll>
      <div class="align-h-space-between align-v-center mb-15">
        @if (title) {
          <h5 class="title">{{ title }}</h5>
        }
        <button
          [disabled]="!form.valid"
          class="btn primary"
        (click)="submit(); menuTrigger.closeMenu()">Save</button>
      </div>
      @for (item of formItems; track item) {
        @if (!item.isDisabled) {
          <div class="row mb-15">
            <mat-label class="col-6 fs-small fw-600">{{ item.label }}</mat-label>
            <!-- Selection field -->
            @if (item.isSelect) {
              <mat-form-field class="col-6 compact">
                <mat-select [formControl]="form.get(item.name)"
                  (selectionChange)="emitControlChanged(item.name, $event.value)">
                  <mat-option [value]="true">Yes</mat-option>
                  <mat-option [value]="false">No</mat-option>
                </mat-select>
              </mat-form-field>
            }
            <!-- Input field -->
            @if (!item.isSelect) {
              <mat-form-field class="col-6 compact">
                @if (!item.isDisabled) {
                  <input
                    [formControl]="form.get(item.name)"
                    matInput type="number">
                }
              </mat-form-field>
            }
          </div>
        }
      }
    </form>
  }
</div>
